import cookie from 'react-cookie';

export function downloadFile(url) {
  let accessToken = cookie.load('accessToken');
  fetch(`${url}`, {
  method: 'GET',
  headers: {
    Authorization: `Bearer ${accessToken}`,
    'Content-Type': 'application/json',
    'Origin' : '*',
  },
  }).then(response => {
    const fileName = response.headers
    .get('content-disposition')
    .split('filename=')[1]
    .replace('"', '')
    .replace('"', '');
      response.blob().then(blob => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      });
  }).catch(error => {
    console.error("Error: " + error);
  });
}


// WEBPACK FOOTER //
// ./src/constants/downloadFile.js